import { Heading } from 'components/text';

import styles from './WelcomeSection.module.scss';
import Container from 'components/container';

import UnionIcon from 'assets/svg/union.svg';

const WelcomeSection: React.FC = () => (
  <Container className={styles.container}>
    <UnionIcon alt="Union icon" />
    <div className={styles.brandSection}>
      <span className={styles.title}>Vault</span>
      <span className={styles.subTitle}>By Little emperors</span>
    </div>
    <Heading as="h1" className={styles.introSection}>
      Our exclusive preferred partner programme <br className='hideMobile'/>designed for luxury hotels
    </Heading>
    <Heading as="h2" className={styles.description}>
      Vault ensures a premium experience for both our members and partner
      hotels, offering exceptional benefits that elevate your property&apos;s
      visibility and appeal. As a Vault partner, you&apos;ll also gain direct
      access to our MyLER community of Independent Travel Advisors, further
      enhancing your reach and driving more bookings.
    </Heading>
  </Container>
);

export default WelcomeSection;
